import { render, staticRenderFns } from "./porposal-detail.vue?vue&type=template&id=3e0bf82c&scoped=true&"
import script from "./porposal-detail.vue?vue&type=script&lang=ts&"
export * from "./porposal-detail.vue?vue&type=script&lang=ts&"
import style0 from "./porposal-detail.vue?vue&type=style&index=0&id=3e0bf82c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e0bf82c",
  null
  
)

export default component.exports